import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import MUIAvatar, { AvatarProps } from '@mui/material/Avatar';
import { SxProps, Theme } from '../styles';
import getUserColor from '../Theme/getUserColor';
import Typography, { Variant } from '../Typography';
export type AvatarSizeProp = 'xs' | 's' | 'm' | 'l';
export const getInitials = (fullName: string) => {
  if (!fullName) return '';
  const nameParts = fullName.split(' ');
  const firstPart = nameParts[0];
  const lastPart = nameParts.length >= 2 ? nameParts[nameParts.length - 1] : null;
  let initials = firstPart.charAt(0);
  if (lastPart) {
    initials += lastPart.charAt(0);
  }
  return initials;
};
const realAvatarUrl = (avatarUrl: string) => avatarUrl && !avatarUrl.includes('avatar_defaut') ? avatarUrl : '';
export interface Props extends AvatarProps {
  children?: ReactNode;
  userName: string;
  userId: string | number;
  shouldHideAriaLabel?: boolean;
  size?: AvatarSizeProp;
  src?: string;
  sx?: SxProps<Theme>;
}
const Avatar = t0 => {
  const $ = _c(35);
  let children;
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let userId;
  let userName;
  if ($[0] !== t0) {
    ({
      children,
      size: t1,
      userName,
      userId,
      src: t2,
      sx: t3,
      shouldHideAriaLabel: t4,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = otherProps;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = userId;
    $[8] = userName;
  } else {
    children = $[1];
    otherProps = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    userId = $[7];
    userName = $[8];
  }
  const size = t1 === undefined ? "s" : t1;
  const src = t2 === undefined ? "" : t2;
  let t5;
  if ($[9] !== t3) {
    t5 = t3 === undefined ? {} : t3;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const sx = t5;
  const shouldHideAriaLabel = t4 === undefined ? false : t4;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      xs: {
        avatarSize: 32,
        initialsVariant: "subheadingSmall"
      },
      s: {
        avatarSize: 40,
        initialsVariant: "subheadingSmall"
      },
      m: {
        avatarSize: 64,
        initialsVariant: "subheading"
      },
      l: {
        avatarSize: 80,
        initialsVariant: "subheading"
      }
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const avatarLayoutProps = t6;
  const t7 = avatarLayoutProps[size];
  const t8 = avatarLayoutProps[size];
  let t9;
  if ($[12] !== userId || $[13] !== userName) {
    t9 = theme => getUserColor(theme.palette, userId, (userName ?? "").toString());
    $[12] = userId;
    $[13] = userName;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== sx || $[16] !== t7.avatarSize || $[17] !== t8.avatarSize || $[18] !== t9) {
    t10 = {
      width: t7.avatarSize,
      height: t8.avatarSize,
      bgcolor: t9,
      textDecoration: "none",
      ...sx
    };
    $[15] = sx;
    $[16] = t7.avatarSize;
    $[17] = t8.avatarSize;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== src) {
    t11 = realAvatarUrl(src);
    $[20] = src;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = shouldHideAriaLabel ? "" : userName;
  const t13 = avatarLayoutProps[size];
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      color: "text.onContrasted",
      textTransform: "uppercase"
    };
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== children || $[24] !== userName) {
    t15 = children || getInitials(userName);
    $[23] = children;
    $[24] = userName;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t12 || $[27] !== t13.initialsVariant || $[28] !== t15) {
    t16 = <Typography aria-label={t12} variant={t13.initialsVariant} sx={t14}>{t15}</Typography>;
    $[26] = t12;
    $[27] = t13.initialsVariant;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== otherProps || $[31] !== t10 || $[32] !== t11 || $[33] !== t16) {
    t17 = <MUIAvatar data-testid="avatar-root" sx={t10} alt="" src={t11} {...otherProps}>{t16}</MUIAvatar>;
    $[30] = otherProps;
    $[31] = t10;
    $[32] = t11;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
};
export default Avatar;